import React,{useState} from "react";
import "./Block.css";
import {useStateValue} from '../StateProvider'
import {Link} from 'react-router-dom'
import FavoriteIcon from '@material-ui/icons/Favorite';


function Block({ id, title, image, price, rating ,quantity}) {

  const [{ basket }, dispatch] = useStateValue();

  const addToDetail = () => {
    dispatch({
      type: "ADD_TO_DETAIL",
      item: {
        id:id,
        title:title,
        image:image,
        price:price,
        rating:rating,
        quantity:quantity,
      },
    });
  };

  const [colour,setColor] = useState('grey');

  const toggle = () => {

    if(colour==='grey'){
        {setColor("red")}

        dispatch({
          type: "ADD_TO_BASKET",
          item: {
            id:id,
            title:title,
            image:image,
            price:price,
            rating:rating,
            quantity:quantity,
          },
        });
  }
  else{
    {setColor("grey")}

    dispatch({
      type: "REMOVE_FROM_BASKET",
      id,
    });
  }
  }

  return (
  
    <div className="product">
      <div  style={{display:'flex', justifyContent:'flex-end',cursor: 'pointer', color:colour}}><FavoriteIcon  onClick={toggle}/></div>
      <div className="product_info">
        <p>{title}</p>
        <p className="product_price">
          <small>$</small>
          {price}
        </p>
      </div>
      
      <img src={image} alt="Product" />
      <Link className="nav-link" exact to ={"/Detail"}onClick={addToDetail} style={{color:'purple'}}>Detail</Link> 
    </div>
  );
}

export default Block;